import React from 'react';
import {Radio, Button} from 'antd';
import Ficon from 'components/Ficon';
import style from './index.less';
import BaseContent from 'components/BaseContent';
import Table from 'components/Table';
import {CreatChartOption} from 'utils/const';
import echarts from 'echarts';
import {getRealUrl} from 'utils/request';
const ButtonGroup = Button.Group;
const RadioButton = Radio.Button;
const RadioGroup = Radio.Group;


class Datapanel extends React.Component {
    state = {
        list:[],
        showType:'table',
        chartData:[],
        outUrl:'',
        data:{}
    }

    chartId = new Date().getTime()+this.MathRand();

    MathRand(){
        let Num = '';
        for(let i=0;i<6;i++)
        {
            Num+=Math.floor(Math.random()*10);
        }
        return Num;
    }

    componentDidMount(){

        window.addEventListener('resize',()=>{
            if(this.myChart){
                const box = document.getElementById(this.chartId);
                if(box && box.clientHeight === 0){
                    return;
                }
                this.myChart.resize();
            }
        });
    }

    resetChange = ()=>{
        if(this.state.showType === 'table'){
            this.table && this.table.resetChange();
        }else{
            this.getData({page_size:0,page_id:1});
        }
    }

    setChart(){
        const {config} = this.props;
        const {chartSeries} = config;
        let _data = this.state.chartData;
        if(!_data){
            _data = [];
        }
        const chartDom = document.getElementById(this.chartId);
        if(!chartDom){
            return;
        }
        this.myChart = echarts.init(chartDom);

        const {xdata,series} = chartSeries(_data);
        const option = CreatChartOption('',xdata,series);
        this.myChart.setOption(option,true);
    }

    onShowTypeChange = (e)=>{
        this.setState({showType:e.target.value});
        if(e.target.value === 'chart'){
            this.getData({page_size:0,page_id:1});
        }
    }


    onStart = (tableParams) => {
        tableParams = tableParams || {};
        const params = {};
        if(tableParams.order){
            params.order_by = tableParams.order;
        }
        if(typeof tableParams.asc !== 'undefined'){
            params.is_asc = tableParams.asc === 1;
        }
        // params.contract_type = [CONTRACT_TYPE.C.value];
        params.page_id = tableParams.current;;
        params.page_size = this.state.showType === 'table' ? tableParams.limit : 0;
        return this.getData(params);
    }

    getData(_params){
        const {getSearchParams,setLoading} = this.props;
        const params = {
            ...getSearchParams(),
            ..._params
        };
        setLoading(true);
        return this.props.getInfoPromise(params).then(e => {
            setLoading(false);
            this.setState({
                data:e.data,
                list: e.data.stats,
                total: e.data.total_count,
                outUrl:e.data.download_link,
                chartData:e.data.chart_data,
            },()=>{
                if(this.state.showType !== 'table'){
                    this.setChart();
                }
            });
        }).catch(()=>{
            setLoading(false);
        });
    }

    onOutputClick = ()=>{
        window.open(getRealUrl(this.state.outUrl));
    }

    render() {
        const {config} = this.props;

        let panel;
        if(this.state.showType === 'table'){
            panel = <Table
                sorter={{field: 'day', order: 'descend'}}
                dataSource={this.state.list}
                columns={config.columns}
                onSubmit={this.onStart}
                total={this.state.total}
                pageSize={this.props.pageSize || 10}
                ref={ref => this.table = ref}
            />;
        }else{
            panel = <div style={{height:'435px',borderTop:'1px #EEEEEE solid'}} id={this.chartId}></div>;
        }

        return (

            <BaseContent>
                <div className={style.statistics}>
                    <h1>{config.name}</h1>
                    {config.subTitleRender && config.subTitleRender(this.state.data)}
                    <div className={style.statisticsButton}>
                        <RadioGroup value={this.state.showType} onChange={this.onShowTypeChange}>
                            <RadioButton className={style.sButtonItem} value="table"><Ficon type="list" />List</RadioButton>
                            <RadioButton className={style.sButtonItem} value="chart"><Ficon type="chart" />Sparkline</RadioButton>
                        </RadioGroup>
                        <ButtonGroup style={{marginLeft:24}}>
                            <Button type="primary" disabled={this.state.outUrl === ''} onClick={this.onOutputClick}>Output</Button>
                        </ButtonGroup>
                    </div>
                </div>
                {panel}
            </BaseContent>

        );
    }

}

export default Datapanel;



// WEBPACK FOOTER //
// ./src/components/BaseMultConsumption/Datapanel.js